<template>
    <div class="tab-pane params " id="specifications" role="tabpanel" aria-expanded="false">
        <article>
            <h2 class="param-title">
                <!--مشخصات فنی-->
                <span>{{productInfo.ShortName}}</span>
            </h2>
            <section v-for="ProductPropertyGroup in productInfo.ProductPropertyGroups">
                <h3 class="params-title">{{ProductPropertyGroup.GroupTitle}}</h3>
                <ul class="params-list">
                    <li v-for="ProductPropertyValue in ProductPropertyGroup.ProductPropertyValue">
                        <div class="params-list-key">
                            <span class="block">{{ProductPropertyValue.PropertyTitle}}</span>
                        </div>
                        <div class="params-list-value">
                            <span class="block">
                                {{ProductPropertyValue.PropertyValue == null || ProductPropertyValue.PropertyValue == '' ? '----' : ProductPropertyValue.PropertyValue}}
                            </span>
                        </div>
                    </li>
                </ul>
            </section>
        </article>
    </div>
</template>

<script>
    export default {
        props: {
            productInfo: {
                type: Object,
            },
        },
    }
</script>

<style scoped>
    .params section {
        float: none;
    }
    .params .params-list li {
        padding: 10px;
        background-color: #f1f0f0;
        margin-right: 90px;
    }

    .params section {
        float: none;
        overflow: hidden;
    }
    .params h3.params-title {
        display: block;
        background-color: #e6dede;
        padding: 13px;
    }

    .params .params-title::before {
        right: 2px;
        bottom: 20px;
    }
    .params .params-title {
        top: 15px;
    }
    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .params .params-list li {
            padding: 15px;
            background-color: #dddd;
            margin-right: 10px;
        }
    }
</style>